package com.milta.feature.team.data.remote.dto

import com.milta.feature.team.domain.entity.TeamMembership
import kotlinx.serialization.Serializable

@Serializable
data class TeamMembershipDto(
    val enterpriseId: String,
    val enterpriseName: String,
    val status: String,
    val connectedAt: String,
)

fun TeamMembershipDto.toDomain() = TeamMembership(
    enterpriseId = enterpriseId,
    enterpriseName = enterpriseName,
    status = status,
    connectedAt = connectedAt,
)
